module.exports = __webpack_public_path__ + "img/0Q3A7692_L.d43ce38c.webp";